export default () => ({
    loading: false,
    throttleTimer: null,
    init() {
        // Throttle function
        const throttle = (fn, delay) => {
            return (...args) => {
                if (this.throttleTimer) return;
                this.throttleTimer = setTimeout(() => {
                    fn.apply(this, args);
                    this.throttleTimer = null;
                }, delay);
            };
        };

        // Initialize IntersectionObserver with reduced margin
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting && !this.loading) {
                        // Throttle loadMore calls
                        throttle(() => this.loadMore(), 300)();
                    }
                })
            },
            { 
                rootMargin: '200px',
                threshold: 0.1
            }
        )
        
        // Observe the loading trigger element
        observer.observe(this.$refs.loadingTrigger)

        // Handle scroll position restoration
        const savedPos = sessionStorage.getItem('listingsScrollPos')
        if (savedPos) {
            requestAnimationFrame(() => {
                window.scrollTo(0, parseInt(savedPos))
                sessionStorage.removeItem('listingsScrollPos')
            })
        }
    },
    beforeUnmount() {
        sessionStorage.setItem('listingsScrollPos', window.scrollY.toString())
    },
    async loadMore() {
        const nextPage = this.$store.listings.next_page
        if (!nextPage || this.loading) return

        this.loading = true
        try {
            const response = await fetch(nextPage, {
                headers: {
                    'Accept': 'application/json',
                    'X-Requested-With': 'XMLHttpRequest'
                }
            })
            if (!response.ok) throw new Error('Failed to load more listings')
            
            const data = await response.json()
            if (!data.html) {
                throw new Error('Invalid response format: missing html content')
            }
            
            // Use DocumentFragment for better performance
            const fragment = document.createDocumentFragment();
            const tempContainer = document.createElement('div');
            tempContainer.innerHTML = data.html;
            
            const listingsGrid = this.$refs.listingsGrid;
            while (tempContainer.firstChild) {
                fragment.appendChild(tempContainer.firstChild);
            }
            listingsGrid.appendChild(fragment);
            
            // Update next page URL (might be null if no more pages)
            this.$store.listings.next_page = data.next_page
            
            // Announce to screen readers
            this.$refs.announcer.textContent = data.next_page 
                ? 'New listings loaded' 
                : 'All listings loaded';
        } catch (error) {
            console.error('Error loading more listings:', error)
            this.$refs.announcer.textContent = 'Failed to load more listings'
        } finally {
            this.loading = false
        }
    }
})
